import React from 'react';

import { includes } from 'lodash-es';
import { useLocation } from 'react-router-dom';

import { injectStores } from '@stores/factories/store-utils';
import { TypeProfileStore } from '@stores/profile-store';
import { useTrans } from '@/custom-hooks/useTrans';

import MenuMessage from './menu-message';
import SwitchLink from '@/components/menus/menu/switch-link/switch-link';

import styles from './unverified-user-menu-message.module.scss';
import COLORS from '../../../styles/legos/colors.module.scss';
const { akDisabledDark } = COLORS;

type Props = {
    ProfileStore: TypeProfileStore;
};
function UnverifiedUserMenuMessageModule(props: Props) {
    const { t } = useTrans();
    const {
        ProfileStore: { userIsLoggedIn, userAccount },
    } = props;
    const { pathname } = useLocation();

    // ToDo HUB-1346 will take care of fixing this. It's not as trivial as it may seem ;-)
    const { profile = {} } = { ...userAccount };
    const { isVerified = false } = { ...profile };

    const messageId = 'UNVERIFIED_USER';

    const suppressRedBanner =
        includes(pathname, '/create-account/') ||
        includes(pathname, 'profile/complete') ||
        includes(pathname, 'profile/create-profile-thank-you') ||
        includes(pathname, 'learning/create-school-account') ||
        isVerified ||
        !userIsLoggedIn;

    if (suppressRedBanner) return null;

    const { part_1, part_2: part_2_temp, part_3 } = t('general:menu-message.UNVERIFIED_USER');
    const part_2 = t(part_2_temp, {
        AK_LINK_PROFILE_COMPLETE: (
            <SwitchLink
                akTestId='UnverifiedUser|RedBanner|CompleteProfile'
                to={{ module: 'PROFILE', subModule: 'COMPLETE_NEW_SSO_ACCOUNT' }}
            />
        ),
    });

    const messageConfig = {
        i18nId: messageId,
        message: '',
        publishDateStart: null,
        publishDateEnd: '2099-12-31',
        cookieResetDate: '',
        cookieExpiry: 1,
        barColor: akDisabledDark,
    };

    return (
        <MenuMessage messageConfig={messageConfig} isDismissable={false}>
            <div className={styles.unverifiedBannerMessage}>
                <div>{part_1}</div>
                <div>{part_2}</div>
                <div>{part_3}</div>
            </div>
        </MenuMessage>
    );
}

export default injectStores(['ProfileStore'])(UnverifiedUserMenuMessageModule);
